import React, { useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Services from './pages/Services';
import Trainers from './pages/Trainers';
import FAQ from './pages/FAQ';
import Access from './pages/Access';
import Recruit from './pages/Recruit';
import './styles/GlobalStyles.css';

const pageTitles: Record<string, string> = {
  '/': 'HOME',
  '/pricing': 'PRICING',
  '/trainer': 'TRAINER',
  '/faq': 'FAQ',
  '/access': 'ACCESS',
  '/recruit': 'RECRUIT',
};

const AppContent: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalizedPath = pathname.replace(/\/+$/, '') || '/';
    const pageTitle = pageTitles[normalizedPath] || 'NOT FOUND';
    document.title = `${pageTitle} | PERSONAL GYM N FUSHIMI | パーソナルジムN伏見`;
  }, [pathname]);

  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Services />} />
          <Route path="/trainer" element={<Trainers />} />
          <Route path="/services" element={<Navigate to="/pricing" replace />} />
          <Route path="/trainers" element={<Navigate to="/trainer" replace />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/access" element={<Access />} />
          <Route path="/recruit" element={<Recruit />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
